import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ICheckPrintDetails } from '../Shared/Interfaces/ICheckWriting';
import { IACHVendorResponseModel, IResponseModel } from '../Shared/model/CommonModel';
import { IVendorACHAutoPay } from '../Shared/Interfaces/IACHAutoPay';

@Injectable()
export class ACHAutoPayService {

    private baseURL: string;
    constructor(private http: HttpClient
    ) {
        this.baseURL = environment.apiBaseUrl;
    }

    getACHAutoPayVendors(vendorId: number): Observable<IVendorACHAutoPay[]> {
        return this.http.get<any>(`${this.baseURL}/vendor/GetAutoACHVendorsWithDue?vendorId=${vendorId}`, { observe: 'response' }).pipe(
            map(res => {
                const result = res.body as IVendorACHAutoPay[];
                return result;
            }),
            catchError(this.handleError));
    }

    
    generatePaymentReceipts(paymentReceiptData): Observable<any> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        const url = `${this.baseURL}/PaymentReceipt/GeneratePaymentReceipts`;
        return this.http.post<any>(url, paymentReceiptData, options)
            .pipe(
            map(res => {
                const response = res as any;
                return response;
            }),
            catchError(this.handleError)
            );
    }

    generateAutoPaySummary(paymentReceiptData: IVendorACHAutoPay[]): Observable<any> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        const url = `${this.baseURL}/PaymentReceipt/GenerateAutoPayACHSummary`;
        return this.http.post<any>(url, paymentReceiptData, options)
            .pipe(
            map(res => {
                const response = res as any;
                return response;
            }),
            catchError(this.handleError)
            );
    }

    processACHAutoPayVendors(model): Observable<IACHVendorResponseModel[]> {
        return this.http.post<any>(`${this.baseURL}/Payment/ProcessACHAutoPayVendors`, model, { observe: 'response' }
        ).pipe(
            map((res: HttpResponse<IACHVendorResponseModel[]>) => res.body),
            catchError(this.handleError)
        );
    }

    // Common error handler
    private handleError(error: HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
            return throwError(() => error.error.message);
        }
        return throwError(() => error.message || 'Server error');
    }
}
